import { createSlotRecipe } from './runtime.js';

const segmentedControlConfig = {"name":"segmentedControl","slots":["root","thumb","item","icon"],"defaultVariants":{"fullWidth":false,"size":"md"},"variantMap":{"fullWidth":["false","true"],"size":["lg","md","sm"]}}

export const segmentedControl = /* @__PURE__ */ createSlotRecipe(segmentedControlConfig)